<div class="audio-player selenium-audio-player">
    <ng-container *ngIf="!userAgentService.isGoogleCrawler; else googleCrawlerSafeAudio">
        <audio
            #player
            class="video-js pbslm-audio-skin vjs-default-skin"
            crossorigin="anonymous"
            controls
            preload="auto"
        ></audio>
        <app-preloader></app-preloader>
    </ng-container>
</div>
<ng-template #googleCrawlerSafeAudio>
    <audio [src]="audioMedia.getURL()" controls></audio>
</ng-template>
